export default __webpack_public_path__ + "static/media/2.d7048849.svg";